// @flow

import $ from "../vendor/jquery";

import {getProductCode, jsonAjax} from "../util";

import Settings from "./Settings";
import Graph from "./Graph";
import {MeasurementWithPasswordType, NominalGraphsResultType} from "../model";
import type {IntegerType} from "../model";
import AppConfig from "../config";
import t from "../trans";
import Popup from "../Popup";
import Legacy from "../Legacy";

/**
 * Nominaalgraafiku haldamise objekt
 */
class NominalGraph {

    /**
     * @type {?NominalGraph}
     */
    static nominalGraphInstance: ?NominalGraph = null;

    /**
     * Tootekood, mille nominaalgraafikut antud objekt kajastab. Kui nominaalgraafikut pole laetud, on selle väätus null.
     * Kui nominaalgraafiku laadimine on hetkel pooleli, siis väätuseks on laetava toote kood ning "points" element on null.
     */
    productNo: ?string;

    /**
     * Nominaalgraafiku punktide massiiv kujul:
     * points[i] - mõõtejoon (i+1) väärtuste massiiv, kus i = 0..2
     * Kui nominaalgraafikut pole laetud, on selle elemendi väärtus null
     */
    points: ?Array<Array<IntegerType>>;

    /**
     * @returns {NominalGraph}
     */
    static getInstance(): NominalGraph {
        if (NominalGraph.nominalGraphInstance == null) NominalGraph.nominalGraphInstance = new NominalGraph();
        return NominalGraph.nominalGraphInstance;
    }

    constructor() {
        /**
         * Tootekood, mille nominaalgraafikut antud objekt kajastab. Kui nominaalgraafikut pole laetud, on selle väätus null.
         * Kui nominaalgraafiku laadimine on hetkel pooleli, siis väätuseks on laetava toote kood ning "points" element on null.
         */
        this.productNo = null;

        /**
         * Nominaalgraafiku punktide massiiv kujul:
         * points[i] - mõõtejoon (i+1) väärtuste massiiv, kus i = 0..2
         * Kui nominaalgraafikut pole laetud, on selle elemendi väärtus null
         */
        this.points = null;
    }

    /**
     * Nominaalgraafiku sisselaadmine
     * @param {string} product - toote kood, mis sisse laadida
     */
    load(product: string): void {
        if (this.productNo == product) return;

        this.points = null;
        this.productNo = product;
        let baseProduct: string = getProductCode(product);

        // Loeme sisse nominaalgraafiku:
        jsonAjax({
            type: "GET",
            url: AppConfig.BASE_URL + "/nominalGraphs/" + baseProduct,
            success: function (data: NominalGraphsResultType) {
                this.loadFinished(data);
            }.bind(this),
            error: function (a, b, c) {
                this.productNo = null;
                this.points = null;
                Popup.show_err(t("Nominal graph was not found"));
            }.bind(this)
        });
    }

    /**
     * Meetod kutsutakse välja automaatselt peale nominaalgraafiku edukat sisselaadimist.
     * Väärtustab nominaalgraafiku punktide massiivi ning kutsub välja graafiku refresh'i, et see vajadusel graafikul kuvataks.
     */
    loadFinished(data: NominalGraphsResultType) {
        Legacy.debug("nnnn.loadFinished");
        if (!data || !data.nominalGraphsResult) {
            this.productNo = null;
            this.points = null;
            return;
        }
        Legacy.debug(data.nominalGraphsResult.toote_variant);
        this.points = [];
        let settings = Settings.getInstance();
        let mootejoon = data.nominalGraphsResult.mootejoon;
        if (mootejoon) {
            for (let i = 0; i < settings.getMeasurementLineCount(); i++) {
                if (!mootejoon[i]) break;
                this.points[i] = mootejoon[i][0];
            }
        }
        this.productNo = data.nominalGraphsResult.toote_variant;

        if ($('#graph0').length > 0) {
            let graph = Graph.getInstance();
            graph.refreshGraphs();
        }
    }

    /**
     * Salvestab etteantud jooned näidatud toote nominaalgraafikuks
     */
    save(product: string, lines: Array<Array<Array<IntegerType>>>) {
        Popup.ask_passwd(function (passwd: string) {
            if (!passwd) return;
            //let baseProduct: string = getProductCode(product);
            let s: MeasurementWithPasswordType = {
                'password': passwd,
                'toote_variant': product,
                "mootejoon": []
            };
            for (let i = 0; i < lines.length; i++) {
                s.mootejoon[i] = [lines[i][0]];
            }

            jsonAjax({
                type: "POST",
                url: AppConfig.BASE_URL + "/nominalGraphs",
                data: JSON.stringify({ data: s }),
                success: function () {
                    if (product == this.productNo) {
                        this.points = [];
                        for (let i = 0; i < lines.length; i++) {
                            this.points[i] = lines[i][0];
                        }
                        if ($('#graph0').length > 0) {
                            let graph = Graph.getInstance();
                            graph.refreshGraphs();
                        }
                    }
                    Popup.show_success(t('Nominal graph saved'));
                }.bind(this),
                error: function () {
                    Popup.show_err(t("Error saving nominal graph"));
                },
                statusCode: {
                    403: function () {
                        Popup.show_err("Invalid password");
                    }
                }
            });
        }.bind(this));
    }
}

export default NominalGraph;
